import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3djswmgi7l: FaireBrandEntity = {
  token: "b_3djswmgi7l",
  type: "brand",
  name: "Coblentz Chocolate Company",
  avatarUrl:
    "https://cdn.faire.com/fastly/77babe99fcdad9d756a49e6f70d74a1c96016b5a27e37429ee45a4f49895fb6d.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/4e402b8155a89b7d59050c30733d8bb36cac59825ad711eed3812acad5ffd8db.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/77babe99fcdad9d756a49e6f70d74a1c96016b5a27e37429ee45a4f49895fb6d.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4e402b8155a89b7d59050c30733d8bb36cac59825ad711eed3812acad5ffd8db.jpeg",
  location: "Walnut Creek, OH, USA",
  minimumOrderDollars: 0,
  rating: 4.9,
  reviewCount: 357,
  isTopShop: true,
  isInsider: true,
  description:
    "Nestled in the heart of Ohio's Amish country, Coblentz Chocolate has been producing quality confections since 1987. Using many locally sourced ingredients we craft caramels, toffees, clusters, creams and more in both impulse and giftable formats sure to please your customers. Everyday and seasonal specific selections available.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T08:29:02.277Z",
    importedBy: "entity-db-cli",
  },
};
